export default "__VITE_ASSET__BhxLWoMq__"